import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { createFilterOptions } from '@material-ui/lab/Autocomplete'
import { Checkbox, TextField } from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { AutocompleteTags } from 'components/Autocomplete/components/AutocompleteTags'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const defaultFilterOptions = createFilterOptions({
  trim: true,
  limit: 100,
})

const defaultGetOptionLabel = (option) => {
  if (option == null) return ''
  if (typeof option === 'string' || typeof option === 'number') return String(option)
  return option.nome || ''
}

const defaultGetOptionSelected = (option, value) => (
  option?.id !== undefined && value?.id !== undefined
    ? option.id === value.id
    : option === value
)

const CheckboxOption = (props) => {
  const { option, state, getOptionLabel } = props
  return (
    <>
      <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={state.selected} />
      {getOptionLabel(option)}
    </>)
}

export const Autocomplete = (props) => {
  const {
    value,
    name,
    label,
    options,
    onChange,
    getOptionLabel = defaultGetOptionLabel,
    getOptionSelected = defaultGetOptionSelected,
    getTagLabel = getOptionLabel,
    getTagTooltip,
    noOptionsText = 'Sem informações',
    multiple = false,
    ...rest
  } = props

  return (
    <AutocompleteNative
      value={value}
      name={name}
      multiple={multiple}
      disableCloseOnSelect
      noOptionsText={noOptionsText}
      filterOptions={defaultFilterOptions}
      options={options}
      onChange={onChange}
      getOptionSelected={getOptionSelected}
      getOptionLabel={getOptionLabel}
      renderTags={(tagValue, getTagProps) => (
        <AutocompleteTags
          tagValue={tagValue}
          getTagProps={getTagProps}
          getLabel={getTagLabel}
          getTooltip={getTagTooltip}
        />
      )}
      renderOption={(option, state) => {
        return multiple ? <CheckboxOption option={option} state={state} getOptionLabel={getOptionLabel} /> : getOptionLabel(option)
      }}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" InputLabelProps={{ shrink: true }} label={label} />
      )}
      {...rest}
    />
  )
}